import api from '@/app/services/financeiro/lancamentos';

export default {
  namespaced: true,
  state: {
    lancamento: {
      id: '',
      tipo: 'pagar',
      descricao: '',
      categoria_id: null,
      conta_financeira_id: null,
      cliente_id: null,
      ordem_servico_id: null,
      valor: null,
      saldo_restante: null,
      forma_pagamento: 'dinheiro',
      data_lancamento: null,
      data_vencimento: null,
      status: 'pendente',
      data_hora_quitacao: null,
      observacao: '',
      origem: 'unico',
      quantidade: 1,
      periodicidade: 'mensal',
    },
    lancamentos: [],
    total_itens: 0,
    resumo: {
      contas_pagar: 0,
      contas_pagas: 0,
      valor_total: 0,
    },
    paginacao: {
      page: 1,
      itemsPerPage: 10,
      sortBy: ['data_vencimento'],
      sortDesc: [false],
    },
    filtros: {
      tipo: 'pagar',
      status: null,
      categoria_id: null,
      conta_financeira_id: null,
      data_inicio: null,
      data_fim: null,
    },
  },

  mutations: {
    LISTAR(state, payload) {
      state.lancamentos = payload;
    },
    ABRIR(state, payload) {
      state.lancamento = payload;
    },
    ADICIONAR(state, payload) {
      if (Array.isArray(payload)) {
        state.lancamentos = [...payload, ...state.lancamentos];
        return;
      }
      state.lancamentos.unshift(payload);
    },
    ATUALIZAR(state, payload) {
      const index = state.lancamentos.findIndex((item) => item.id == payload.id);
      if (index > -1) {
        state.lancamentos.splice(index, 1, payload);
      }
    },
    EXCLUIR(state, id) {
      const index = state.lancamentos.findIndex((item) => item.id == id);
      if (index > -1) {
        state.lancamentos.splice(index, 1);
      }
    },
    SET_TOTAL_ITENS(state, total) {
      state.total_itens = total;
    },
    SET_RESUMO(state, resumo) {
      state.resumo = resumo;
    },
    UPDATE_PAGINACAO(state, paginacao) {
      state.paginacao = paginacao;
    },
    SET_PAGE(state, page) {
      state.paginacao.page = page;
    },
    SET_FILTRO(state, { campo, valor }) {
      state.filtros[campo] = valor;
    },
    SET_TIPO(state, tipo) {
      state.filtros.tipo = tipo;
      state.lancamento.tipo = tipo;
    },
    ZERAR(state) {
      state.lancamento = {
        id: '',
        tipo: state.filtros.tipo,
        descricao: '',
        categoria_id: null,
        conta_financeira_id: null,
        cliente_id: null,
        ordem_servico_id: null,
        valor: null,
        saldo_restante: null,
        forma_pagamento: 'dinheiro',
        data_lancamento: null,
        data_vencimento: null,
        status: 'pendente',
        data_hora_quitacao: null,
        observacao: '',
        origem: 'unico',
        quantidade: 1,
        periodicidade: 'mensal',
      };
    },
  },

  actions: {
    async listar({ commit, state }) {
      commit('LOADING_ON', null, { root: true });

      const { sortBy, sortDesc, page, itemsPerPage } = state.paginacao;
      const params = {
        page,
        itemsPerPage,
        sortBy: sortBy[0],
        sortDesc: sortDesc[0],
        ...state.filtros,
      };

      Object.keys(params).forEach((key) => {
        if (params[key] === null || params[key] === '' || typeof params[key] === 'undefined') {
          delete params[key];
        }
      });

      const response = await api.listar(params);
      commit('LISTAR', response.data);
      commit('SET_TOTAL_ITENS', response.total);
      commit('SET_RESUMO', response.resumo);
      commit('LOADING_OFF', null, { root: true });
    },

    async abrir({ commit }, id) {
      commit('LOADING_ON', null, { root: true });
      const lancamento = await api.abrir(id);
      commit('ABRIR', lancamento);
      commit('LOADING_OFF', null, { root: true });
    },

    async salvar({ commit }, payload) {
      const novo = await api.salvar(payload);
      commit('ADICIONAR', novo);
    },

    async atualizar({ commit }, payload) {
      const atualizado = await api.atualizar(payload);
      commit('ATUALIZAR', atualizado);
    },

    async excluir({ commit }, id) {
      await api.excluir(id);
      commit('EXCLUIR', id);
    },

    async quitar({ commit }, { id, data_hora_quitacao }) {
      const atualizado = await api.quitar(id, data_hora_quitacao);
      commit('ATUALIZAR', atualizado);
    },

    async estornar({ commit }, id) {
      const atualizado = await api.estornar(id);
      commit('ATUALIZAR', atualizado);
    },
  },
};
